module.exports = __webpack_public_path__ + "static/About-icon-4-Tech-e24995c1e53d650154470917ac908c44.png";